import { ELayerType } from '../../types/ELayerType';
import { IDriverset } from './Driverset';

interface ISystemProxy {
  uuid: string;
  name: string;
  // country/division can be unset (e.g. user just changed country, division
  // gets reset to undefined until they pick a new one).
  country?: string;
  division?: string;
  users_count?: number;
  driversets_count?: number;
  layers_count?: number;
}

interface ISystemLayer {
  name: string;
  type: ELayerType;
  data: any;
}

interface ISystem extends ISystemProxy {
  hydrated?: boolean;
  layers: ISystemLayer[];
  driversets: IDriverset[];
  created_at?: string;
  updated_at?: string;
}

export { ISystemProxy, ISystemLayer, ISystem }
